import { z } from 'zod'

// Кросс-контекстный VO файла. Байты идут в S3 напрямую по presigned-URL;
// в теле create-фич уходит metadata (bucket/key/...), в read-DTO приходит url.
// Форма зеркалит бэкенд (snake_case).

export const FileRefSchema = z.object({
  bucket: z.string(),
  key: z.string(),
  file_name: z.string(),
  content_type: z.string().optional(),
  size: z.number(),
  url: z.string().optional(),
})
export type FileRef = z.infer<typeof FileRefSchema>

const KB = 1024
const MB = KB * 1024
const GB = MB * 1024

// «1,4 МБ» — компактный человекочитаемый размер.
export function formatSize(bytes: number): string {
  if (bytes < KB) return `${bytes} Б`
  if (bytes < MB) return `${round(bytes / KB)} КБ`
  if (bytes < GB) return `${round(bytes / MB)} МБ`
  return `${round(bytes / GB)} ГБ`
}

function round(n: number): string {
  return n.toLocaleString('ru-RU', { maximumFractionDigits: 1 })
}

// Расширение файла (без точки, нижним регистром) — для иконки типа.
export function fileExt(file: Pick<FileRef, 'file_name'>): string {
  const dot = file.file_name.lastIndexOf('.')
  return dot > 0 ? file.file_name.slice(dot + 1).toLowerCase() : ''
}
